import { FC } from 'react'
import { styled } from '@sans-souci/styles'
import { Loader } from './Loader'
import { Container } from '../Container/Container'

const Root = styled(Container, {
  color: '$black',
})
const LoaderContainer = styled('div', {
  display: 'grid',
  justifyContent: 'center',
  alignItems: 'center',
  color: '$black',
  height: '100vh',
  '@lg': {
    height: '100vh',
  },
})

export const FullPageLoader: FC = () => {
  return (
    <Root>
      <LoaderContainer>
        <Loader size={'medium'} />
      </LoaderContainer>
    </Root>
  )
}
